import React from 'react'

import { Link as RouterLink, useHistory, useLocation } from 'react-router-dom'
import { RHFInput } from 'react-hook-form-input'
import useForm from 'react-hook-form'

import {
  Button,
  Card,
  LinearProgress,
  TextField,
  Typography,
  Link,
  makeStyles,
} from '@material-ui/core'

import logo from 'images/yapay.svg'
import styles from './styles'
import schemas from './schemas'
import useAuth from 'hooks/useAuth'
import useSnackbar from 'hooks/useSnackbar'

const useStyles = makeStyles(styles)

export const Login = () => {
  const classes = useStyles()
  const auth = useAuth()
  const snackbar = useSnackbar()
  const location = useLocation()
  const history = useHistory()

  const { register, setValue, handleSubmit, errors } = useForm({
    validationSchema: schemas.login,
    defaultValues: {
      email: '',
      password: '',
    },
  })

  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    if (location.state && location.state.clearAuth) {
      auth.resetAuthData()
      history.replace({ pathname: location.pathname, state: null }) // clear state after logout
    }
    // eslint-disable-next-line
  }, [])

  const onSubmit = async data => {
    setLoading(true)

    try {
      await auth.login(data)
    } catch (error) {
      setLoading(false)

      if (error && error.response && error.response.status === 401) {
        snackbar.open({
          message: 'Email ou senha inválidos',
          variant: 'error',
        })

        return
      }

      snackbar.open({
        message: 'Ocorreu algum erro! Tente novamente!',
        variant: 'error',
      })
    }
  }

  return (
    <>
      <img alt="Logo" src={logo} width="100%" className={classes.logo} />

      <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
        <Card className={classes.card}>
          {loading && <LinearProgress className={classes.progress} />}

          <Typography variant="h4" align="center" className={classes.title}>
            Bem-vindo(a)!
          </Typography>

          <div className={classes.fields}>
            <RHFInput
              as={
                <TextField
                  label="Email"
                  type="email"
                  variant="outlined"
                  error={!!errors.email}
                  helperText={errors && errors.email && errors.email.message}
                  fullWidth
                />
              }
              register={register}
              setValue={setValue}
              name="email"
              mode="onChange"
            />

            <RHFInput
              as={
                <TextField
                  label="Senha"
                  type="password"
                  variant="outlined"
                  margin="normal"
                  error={!!errors.password}
                  helperText={
                    errors && errors.password && errors.password.message
                  }
                  fullWidth
                />
              }
              register={register}
              setValue={setValue}
              name="password"
              mode="onChange"
            />
          </div>

          <Button
            variant="contained"
            color="primary"
            type="submit"
            size="large"
            className={classes.buttonContinue}
            fullWidth
            disabled={loading}
          >
            {loading ? 'Carregando...' : 'Continuar'}
          </Button>

          <Link component={RouterLink} to="/password/reset">
            <Typography className={classes.linkPassword}>
              Esqueci minha senha
            </Typography>
          </Link>
        </Card>
      </form>
    </>
  )
}

export default Login
